import { useState } from "react"
import Modal from "../../../components/Modal"
import Table from "../../../components/Table"
import LastTalentsSkeleton from "../../../skeleton/TalentManager/LastTalentsSkeleton"
import { useQuery } from "@tanstack/react-query"
import { listUploadFilesRecruiter } from "../../../services/MyCurriculumn"
import Pagination from "../../../components/Pagination"
import { ITEMS_PER_PAGE } from "../../../utils/constants"

const HistoryPdfsModal = () => {
    const [page, setPage] = useState(0)

    const {
        data: queryData,
        isFetching: isLoadingHistory,
      } = useQuery({
        queryKey: ['listUploadFilesRecruiter', page],
        queryFn: () => listUploadFilesRecruiter({ page, pageSize: ITEMS_PER_PAGE }).then(r => r.data),
        keepPreviousData: true,
      })

    
      const HeadComponent = () => (
        <tr>
          <th>ID</th>
          <th>Archivo</th>
          <th>Fecha subida</th>
          <th>Nota</th>
          <th>Estado</th>
          <th>Lectura</th>
        </tr>
      )
      
      const BodyComponent = ({ data }) => {
        if (!data || data.length === 0) {
          return (
            <tr>
              <td colSpan={6} className="text-center">No hay PDFs cargados previamente.</td>
            </tr>
          )
        }
        return data.map(row => (
          <tr key={row.id}>
            <td>{row.id}</td>
            <td>
              <a href={row.url} target="_blank" rel="noopener noreferrer fontSize12">
                Ver pdf
              </a>
            </td>
            <td className="fontSize12">{row.date ? new Date(row.date).toLocaleString() : ''}</td>
            <td>{row.note && row.note !== 'false' ? row.note : '-'}</td>
            <td>{row.blocked ? 'Bloqueado' : 'OK'}</td>
            <td className="fontSize12">{row.reading ? (row.reading_date ? new Date(row.reading_date).toLocaleString() : 'Sí') : 'No'}</td>
          </tr>
        ))
      }

  return (
    <Modal
      modalId="historyModal"
      title="Historial de PDFs cargados"
      modalSize="modal-lg"
      renderCloseButton
      renderTitle
      renderModalHeader
    >
      <div
        className="bg-white rounded shadow-sm p-4 mt-3"
        style={{ maxWidth: '950px', minHeight: '320px' }}
      >
        {isLoadingHistory ? (
          <LastTalentsSkeleton />
        ) : (
          <Table
            HeadComponent={HeadComponent}
            BodyComponent={() => BodyComponent({ data: queryData?.list || [] })}
            className="table-bordered table-hover table-sm text-on-bg-primary font-small"
          />
        )}
        <div className="overflow-auto mb-3">
          <Pagination
            totalItems={queryData?.count || 0}
            itemsPerPage={ITEMS_PER_PAGE}
            page={page}
            setPage={setPage}
            className="mt-3 m-0 p-0"
          />
        </div>
      </div>
    </Modal>
  )
}

export default HistoryPdfsModal